import { useAtomValue, useSetAtom } from 'jotai';

import {
  authenticationGateSourceAtom,
  isLoggedInAtom,
  presentLoginSheet,
  presentSignUpSheet,
  type AuthenticationGateSource,
} from 'app/atoms';
import { useUISize } from 'app/utils/web-helpers';
import { navigationRef } from 'app/lib/root-navigation';
import type { SpecificNavigationProp } from 'app/types/navigation';
import { Platform } from 'react-native';

export function useAuthorize(defaultSource: AuthenticationGateSource = 'unknown') {
  const navigation = navigationRef as unknown as SpecificNavigationProp;
  const isLoggedIn = useAtomValue(isLoggedInAtom);
  const { isLargeUI, isSmallUI } = useUISize();
  const setLoginSheetVisible = useSetAtom(presentLoginSheet);
  const setSignUpSheetVisible = useSetAtom(presentSignUpSheet);
  const setAuthenticationGateSource = useSetAtom(authenticationGateSourceAtom);
  return (cb: () => unknown, source: AuthenticationGateSource = defaultSource) => {
    if (!isLoggedIn) {
      if (Platform.OS === 'web') {
        setAuthenticationGateSource(source);
        if (isSmallUI) {
          setSignUpSheetVisible(true);
        } else {
          setLoginSheetVisible(true);
        }
        return false;
      }
      if (isLargeUI) {
        navigation.navigate('onboardingIntro', undefined, { pop: true });
      } else {
        navigation.reset({ routes: [{ name: 'presentPartageClub' }] });
      }
    } else {
      cb();
      return true;
    }
  };
}
